module.exports = __webpack_public_path__ + "img/mastercard.0355da65.png";